import script from "./LingoStudentGrammarListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoStudentGrammarListView.vue?vue&type=script&setup=true&lang=ts"

import "./LingoStudentGrammarListView.vue?vue&type=style&index=0&id=8f238a90&lang=scss&scoped=true"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f238a90"]])

export default __exports__